import React from "react";
import { observer } from "mobx-react";
import { TenantWidgetAccessUpdateStore } from "../../store";
import { TenantWidgetAccessUpdateForm } from "./TenantWidgetAccessUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type TenantWidgetAccessUpdateProps = {
  tenantWidgetAccessUpdateStore: TenantWidgetAccessUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantWidgetAccessUpdate: React.FC<TenantWidgetAccessUpdateProps> =
  observer(
    ({ tenantWidgetAccessUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={tenantWidgetAccessUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={tenantWidgetAccessUpdateStore.savedButOutdated}
            onReload={() =>
              tenantWidgetAccessUpdateStore.reloadTenantWidgetAccess()
            }
            reloadDisabled={tenantWidgetAccessUpdateStore.isProcessing}
          />
          <TenantWidgetAccessUpdateForm
            tenantWidgetAccessUpdateStore={tenantWidgetAccessUpdateStore}
            tenantError={tenantWidgetAccessUpdateStore.errors.tenant?.message}
            onTenantChange={(value) => {
              tenantWidgetAccessUpdateStore.setTenantValue(value);
            }}
            tenantSelectedValue={
              tenantWidgetAccessUpdateStore.entityValues.showTenant
            }
            onTenantSelected={(value) => {
              tenantWidgetAccessUpdateStore.setSelectedTenant(value);
            }}
            tenantOptions={tenantWidgetAccessUpdateStore.getTenantOptions()}
            widgetError={tenantWidgetAccessUpdateStore.errors.widget?.message}
            onWidgetChange={(value) => {
              tenantWidgetAccessUpdateStore.setWidgetValue(value);
            }}
            widgetSelectedValue={
              tenantWidgetAccessUpdateStore.entityValues.showWidget
            }
            onWidgetSelected={(value) => {
              tenantWidgetAccessUpdateStore.setSelectedWidget(value);
            }}
            widgetOptions={tenantWidgetAccessUpdateStore.getWidgetOptions()}
            enabledError={tenantWidgetAccessUpdateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              tenantWidgetAccessUpdateStore.setEnabledValue(value);
            }}
            enabled={tenantWidgetAccessUpdateStore.entityValues.enabled}
            configOverrideError={
              tenantWidgetAccessUpdateStore.errors.configOverride?.message
            }
            onConfigOverrideChange={(value: string) => {
              tenantWidgetAccessUpdateStore.setConfigOverrideValue(value);
            }}
            configOverride={
              tenantWidgetAccessUpdateStore.entityValues.configOverride
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={tenantWidgetAccessUpdateStore.saveDisabled}
            onSave={() =>
              tenantWidgetAccessUpdateStore.saveTenantWidgetAccess()
            }
            onCancel={() =>
              tenantWidgetAccessUpdateStore.cancelTenantWidgetAccess()
            }
          />
          <ErrorDialog
            open={tenantWidgetAccessUpdateStore.errorDialogOpened}
            title={tenantWidgetAccessUpdateStore.errorTitle}
            description={tenantWidgetAccessUpdateStore.errorDescription}
            onClose={() => tenantWidgetAccessUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={tenantWidgetAccessUpdateStore.confirmDialogOpened}
            title={tenantWidgetAccessUpdateStore.confirmDialogTitle}
            description={tenantWidgetAccessUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              tenantWidgetAccessUpdateStore.executeConfirmedAction()
            }
            onCancel={() => tenantWidgetAccessUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
